import { Loading } from "notiflix";
import toast from "react-hot-toast";
import { X, Plus, RefreshCw, Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../Components/Loading/Spinner";
import { SearchEvents } from "../../redux/actions/Events";
import Carousal from "../Components/PagesComponents/Layout/Carousal";
import { AdminCreateCarousal, GetAllCraousalEvent } from "../../redux/actions/Admin/AdminActions";
import { ApiMediaURL } from "../../setting/GlobleVariable";

const inputClass =
  "w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] placeholder:text-white/25 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";

const labelClass =
  "block text-[10px] text-white/40 uppercase tracking-wider mb-1.5";

const isEventSelected = (ev) => Boolean(ev?.id ?? ev?._id);

const Layout = () => {
  const [createCarousal, setCreateCarousal] = useState(false);
  const [image, setImage] = useState(null);
  const [mediaType, setMediaType] = useState("image");
  const [search, setSearch] = useState("");
  const [Paragraph, setParagraph] = useState("");
  const [event, setEvent] = useState({});
  const [isOverLay, setisOverLay] = useState(true);
  const [showDropdown, setDropDown] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [existingMediaUrl, setExistingMediaUrl] = useState(null);
  const dispatch = useDispatch();
  const UserLocationdata = {};

  const serachevents = useSelector((state) => state.events.serachevents);
  const isLoading = useSelector((state) => state.events.isLoading);
  const adminloading = useSelector((state) => state.Admin.adminloading);
  const carousalData = useSelector((state) => state.Admin.carousalData);

  const clearPreviewUrl = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl(null);
  };

  const resetForm = () => {
    clearPreviewUrl();
    setExistingMediaUrl(null);
    setCreateCarousal(false);
    setSearch("");
    setParagraph("");
    setEvent({});
    setIsUpdate(false);
    setId(null);
    setImage(null);
    setMediaType("image");
    setDropDown(null);
    setisOverLay(true);
  };

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const uploadMediaChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    clearPreviewUrl();
    setImage(null);

    if (file.type.startsWith("video/")) {
      setMediaType("video");
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else if (file.type.startsWith("image/")) {
      setMediaType("image");
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      toast.error("Please upload an image or video file");
    }
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (!value) {
      setEvent({});
      return;
    }
    const filterEvent = serachevents?.filter(
      (item) => String(item.id) === String(value)
    );
    setEvent(filterEvent?.[0] || {});
  };

  const createCarousalFunction = async () => {
    if (!isEventSelected(event)) {
      return toast.error("Please select an event");
    }
    if (!Paragraph?.trim()) {
      return toast.error("Please enter carousel paragraph");
    }
    if (!image && !isUpdate) {
      return toast.error("Please upload carousel media");
    }
    if (isUpdate) {
      if (image) {
        const formdata = new FormData();
        formdata.append("event", JSON.stringify(event));
        formdata.append("paragraph", Paragraph);
        formdata.append("file", image);
        formdata.append("isOverLay", isOverLay);
        formdata.append("mediaType", mediaType);
        await dispatch(AdminCreateCarousal(formdata, `update/${id}`));
        resetForm();
      } else {
        const formdata = new FormData();
        formdata.append("event", JSON.stringify(event));
        formdata.append("paragraph", Paragraph);
        formdata.append("isOverLay", isOverLay);
        await dispatch(AdminCreateCarousal(formdata, `update/${id}`));
        resetForm();
      }
    } else {
      const formdata = new FormData();
      formdata.append("event", JSON.stringify(event));
      formdata.append("paragraph", Paragraph);
      formdata.append("file", image);
      formdata.append("isOverLay", isOverLay);
      formdata.append("mediaType", mediaType);
      await dispatch(AdminCreateCarousal(formdata, "create"));
      resetForm();
    }
  };

  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait", { svgColor: "#E52324" });
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  useEffect(() => {
    dispatch(GetAllCraousalEvent());
  }, [dispatch]);

  const EditCarousal = (item) => {
    clearPreviewUrl();
    setImage(null);
    setSearch(item?.event[0]?.name);
    setId(item?._id);
    setParagraph(item?.paragraph);
    setEvent(item?.event[0]);
    setMediaType(item?.mediaType || "image");
    setisOverLay(item?.isOverLay !== false);
    const isVideo = item?.mediaType === "video";
    const path = isVideo ? item?.video : item?.image;
    setExistingMediaUrl(path ? `${ApiMediaURL}/${path}` : null);
    setCreateCarousal(true);
    setIsUpdate(true);
    setDropDown(true);
  };

  return (
    <div
      className="p-6 sm:p-8"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
            Banner Management
          </h1>
          <p className="text-white/30 text-[12px] mt-1">
            Manage hero carousel banners on the marketplace homepage (
            {carousalData?.length ?? 0} total).
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => dispatch(GetAllCraousalEvent())}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:bg-white/[0.03] text-[12px] transition-all"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className="w-4 h-4" />
            Reload
          </button>
          <button
            type="button"
            onClick={() => {
              resetForm();
              setCreateCarousal(true);
              setIsUpdate(false);
            }}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] transition-all shadow-lg shadow-[#E52324]/20"
            style={{ fontWeight: 600 }}
          >
            <Plus className="w-4 h-4" />
            Add Banner
          </button>
        </div>
      </div>

      <Carousal EditCarousal={EditCarousal} />

      {createCarousal && (
        <div className="fixed inset-0 z-[99] flex items-center justify-center p-4 bg-black/60">
          <div className="relative w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-xl">
            <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
              <h3 className="text-[16px] text-white" style={{ fontWeight: 700 }}>
                {isUpdate ? "Update Banner" : "New Banner"}
              </h3>
              <button
                type="button"
                onClick={resetForm}
                className="p-1.5 rounded-lg text-white/40 hover:text-white hover:bg-white/[0.05] transition-all"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-5 py-5 space-y-5">
              <div>
                <label htmlFor="banner-search" className={labelClass}>
                  Search Event By Name
                </label>
                <div className="flex gap-2">
                  <input
                    id="banner-search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && search) {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                    type="text"
                    placeholder="Please Enter Event Name"
                    className={inputClass}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] shrink-0 transition-colors"
                    style={{ fontWeight: 600 }}
                    onClick={() => {
                      if (search) {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                  >
                    <Search className="w-4 h-4" />
                    Search
                  </button>
                </div>
              </div>

              {showDropdown && (
                <div>
                  <label htmlFor="banner-event" className={labelClass}>
                    Select Event
                  </label>
                  <select
                    id="banner-event"
                    className={`${inputClass} cursor-pointer`}
                    value={event?.id ?? event?._id ?? ""}
                    onChange={handleSelectChange}
                  >
                    <option value="" className="bg-[#0B1120]">
                      Please select an event
                    </option>
                    {isLoading ? (
                      <option value="" disabled className="bg-[#0B1120]">
                        Loading...
                      </option>
                    ) : (
                      serachevents?.map((item, index) => (
                        <option key={index} value={item?.id} className="bg-[#0B1120]">
                          {item?.name}
                        </option>
                      ))
                    )}
                  </select>
                  {isLoading && (
                    <div className="mt-2 flex justify-center">
                      <Spinner />
                    </div>
                  )}
                </div>
              )}

              <div>
                <label htmlFor="banner-paragraph" className={labelClass}>
                  Carousal Paragraph
                </label>
                <input
                  id="banner-paragraph"
                  value={Paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  type="text"
                  placeholder="Please Enter Paragraph"
                  className={inputClass}
                />
              </div>

              <div>
                <span className={labelClass}>Media Type</span>
                <div className="flex gap-6">
                  <label className="flex items-center gap-2 cursor-pointer text-[13px] text-white/70">
                    <input
                      type="radio"
                      name="mediaType"
                      value="image"
                      checked={mediaType === "image"}
                      onChange={(e) => {
                        setMediaType(e.target.value);
                        clearPreviewUrl();
                        setImage(null);
                      }}
                      className="accent-[#E52324]"
                    />
                    Image
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer text-[13px] text-white/70">
                    <input
                      type="radio"
                      name="mediaType"
                      value="video"
                      checked={mediaType === "video"}
                      onChange={(e) => {
                        setMediaType(e.target.value);
                        clearPreviewUrl();
                        setImage(null);
                      }}
                      className="accent-[#E52324]"
                    />
                    Video
                  </label>
                </div>
              </div>

              <div>
                <label htmlFor="banner-media" className={labelClass}>
                  Carousel {mediaType === "video" ? "Video" : "Image"}
                </label>
                <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl bg-white/[0.04] border border-white/[0.08] px-4 py-3">
                  <label
                    htmlFor="banner-media"
                    className="inline-flex items-center justify-center shrink-0 px-4 py-2 rounded-lg bg-[#E52324]/20 text-[#E52324] text-[12px] cursor-pointer hover:bg-[#E52324]/30 transition-colors"
                    style={{ fontWeight: 600 }}
                  >
                    Choose File
                  </label>
                  <span className="text-[13px] text-white/50 truncate min-w-0">
                    {image?.name
                      ? image.name
                      : isUpdate && existingMediaUrl
                        ? "Current media (upload to replace)"
                        : "No file chosen"}
                  </span>
                  <input
                    id="banner-media"
                    key={mediaType}
                    onChange={uploadMediaChange}
                    type="file"
                    accept={mediaType === "video" ? "video/*" : "image/*"}
                    className="sr-only"
                  />
                </div>
                {isUpdate && !image ? (
                  <p className="mt-2 text-[11px] text-white/25">
                    Leave empty to keep existing media.
                  </p>
                ) : null}
                {(previewUrl || existingMediaUrl) && (
                  <div className="mt-3 w-full max-h-48 rounded-xl overflow-hidden border border-white/[0.08] bg-black">
                    {mediaType === "video" ? (
                      <video
                        src={previewUrl || existingMediaUrl}
                        className="w-full max-h-48 object-contain"
                        muted
                        playsInline
                        autoPlay={!!previewUrl}
                        loop={!!previewUrl}
                      />
                    ) : (
                      <img
                        src={previewUrl || existingMediaUrl}
                        alt="Banner preview"
                        className="w-full max-h-48 object-contain"
                      />
                    )}
                  </div>
                )}
              </div>

              <label className="flex items-center gap-2.5 cursor-pointer text-[13px] text-white/70">
                <input
                  type="checkbox"
                  checked={isOverLay}
                  onChange={() => setisOverLay(!isOverLay)}
                  className="rounded accent-[#E52324] w-4 h-4"
                />
                Overlay
              </label>

              <button
                type="button"
                className="w-full py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[14px] transition-colors"
                style={{ fontWeight: 700 }}
                onClick={createCarousalFunction}
              >
                {isUpdate ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
